import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbItemDirective, BreadcrumbComponent } from 'xng-breadcrumb';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [
    RouterModule,
    BreadcrumbComponent,
    BreadcrumbItemDirective,
    MatIcon,
    MatChipListbox,
    MatChipOption,
    TranslateModule,
  ],
})
export class BreadcrumbWrapperComponent {}
